import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Container } from 'flux/utils';
import { StatTypes } from '../../constants/CentricConstants';
import buildContextMenu from '../Common/BuildContextMenu';

import DetailView from '../Common/DetailView';

import FlatButton from 'material-ui/FlatButton';
import StatWidget from './StatWidget';
import StaffTrainingWidget from './StaffTrainingWidget';
import MyTrainingWidget from '../MyTraining/MyTrainingWidget';
import ResourceWidget from './ResourceWidget';

import SchoolIcon from 'material-ui/svg-icons/social/school';
import PersonIcon from 'material-ui/svg-icons/social/person';
import VisitsIcon from 'material-ui/svg-icons/action/timeline';
import LibraryIcon from 'material-ui/svg-icons/av/library-books';
import CancelIcon from 'material-ui/svg-icons/navigation/cancel';
import PeopleOutLineIcon from 'material-ui/svg-icons/social/people-outline';

import StatStore from '../../stores/StatStore';
import UserActions from '../../actions/UserActionCreator';
import CourseActions from '../../actions/CourseActionCreator';
import ModuleActions from '../../actions/ModuleActionCreator';

import AssignmentActions from '../../actions/AssignmentActionCreator';
import CourseComplianceStore from '../../stores/CourseComplianceStore';
import { MyComplianceContainer } from '../Compliance/ComplianceContainer';
import LibraryWidget from './LibraryWidget';
import SettingStore from '../../stores/SettingStore';

const getActions = () => [
    {
        link: '/logout',
        icon: <CancelIcon />,
        label: 'Sign out',
    },
];

class Dashboard extends Component {

    constructor() {
        super(...arguments);
        this.actions = buildContextMenu(getActions());
    }

    componentDidMount() {
        UserActions.getCount();
        UserActions.getArchivedCount();
        UserActions.getVisitStats();

        CourseActions.getCount();
        CourseActions.getStats();
        CourseActions.getMyEnrolmentStats();

        ModuleActions.getMyClassesStats();
        ModuleActions.getModuleCount();
        ModuleActions.getResourceCount();
        ModuleActions.getMyResourceStats();

        AssignmentActions.getCount();

    }

    render() {

        const isAdmin = this.context.auth.isAdmin();
        const isManager = this.context.auth.isManager();

        let widgets = [];

        widgets.push(
            <div className="cent-col-1" key="myComplianceContainer">
                <MyComplianceContainer />
            </div>
        );

        if (this.state.siteKey !== 'NOSTATS') {

            if (this.state.myEnrolmentStats.length || this.state.myResourceStats.length) {
                let myTrainingDataProps = {
                    courseEnrolments: this.state.myEnrolmentStats,
                    resourceEnrolments: this.state.myResourceStats,
                    cardActions: [
                        <FlatButton
                            key="allTraining"
                            label="Display all"
                            href="/dashboard/mytraining/courses"
                        />
                    ]
                };
                widgets.push(
                    <div className="cent-col-1" key="myTrainingWidget">
                        <MyTrainingWidget {...myTrainingDataProps} />
                    </div>
                );
            }

        }

        if (isManager) {

            if (this.state.courseStats.length) {
                let allStaffProps = {
                    subtitle: 'Grouped by courses or users',
                    enrolments: this.state.courseStats,
                    cardActions: [
                        <FlatButton
                            key="byUser"
                            label="By user"
                            href="/dashboard/courses/enrolments/stats/group/user"
                        />
                    ]
                };
                widgets.push(
                    <div className="cent-col-1" key="staffTrainingWidget">
                        <StaffTrainingWidget {...allStaffProps} />
                    </div>
                );
            }
        }

        if (this.state.classCount > 0) {
            const classProps = {
                title: 'My classes',
                subtitle: 'Designated as a trainer',
                url: '/dashboard/myteaching/modules',
                icon: SchoolIcon,
                count: this.state.classCount
            };

            widgets.push(
                <div className="cent-col-1" key="classWidget">
                    <StatWidget {...classProps} />
                </div>
            );
        }

        const statWidgetProps = [];

        if (isManager) {
            // no extra widgets for managers
        }

        widgets.push(
            <div className="cent-col-1" key="resourceData">
                <div className="cent-flex-row">
                    <LibraryWidget />
                    <ResourceWidget />
                </div>
            </div>
        );

        if (isAdmin) {
            statWidgetProps.push(
                {
                    title: 'Courses',
                    url: '/dashboard/courses',
                    icon: SchoolIcon,
                    hideOnNull: true,
                    count: this.state.courseCount,
                    actions: [
                        <FlatButton key="searchCourse" label="Search" href="/dashboard/courses?search" />
                    ]
                },
                {
                    title: 'Modules',
                    url: '/dashboard/modules',
                    icon: SchoolIcon,
                    hideOnNull: true,
                    count: this.state.moduleCount,
                    actions: [
                        <FlatButton key="findModules" label="Search" href="/dashboard/modules?search" />,
                    ]
                },
                {
                    title: 'Resources',
                    url: '/dashboard/modules/resource',
                    icon: LibraryIcon,
                    hideOnNull: true,
                    count: this.state.resourceCount,
                    actions: [
                        <FlatButton key="findMedia" label="Search" href="/dashboard/modules/resource/search" />,
                        <FlatButton key="searchMedia" label="Search Content" href="/dashboard/modules/resource/search?content" />,
                    ]
                },
                {
                    title: 'Assignments',
                    url: '/dashboard/assignments',
                    icon: PeopleOutLineIcon,
                    hideOnNull: true,
                    count: this.state.assignmentCount
                },
                {
                    title: 'Users',
                    url: '/dashboard/users',
                    icon: PersonIcon,
                    count: this.state.userCount,
                    statString: !!this.state.archivedUserCount ? ` (${this.state.archivedUserCount} archived)` : null
                },
                {
                    title: 'Visits',
                    url: '/dashboard/users',
                    icon: VisitsIcon,
                    count: Number(this.state.visitStats.visits) || 0
                }
            );
        }

        if (statWidgetProps.length > 0) {
            widgets.push(
                <div className="cent-col-1" key="statWidgets">
                    <div className="cent-flex-row">
                        {statWidgetProps
                            .filter(props => !!props && !!props.count)
                            .map((props, i) => (<StatWidget key={i} {...props} />))}
                    </div>
                </div>
            );
        }

        return (
            <DetailView title={this.state.title} actions={this.actions}>
                <div className="cent-cards" >
                    {widgets}
                </div>
            </DetailView>
        );
    }

}

Dashboard.contextTypes = {
    auth: PropTypes.object.isRequired
};

const sanitise = (stats) => ({
    assignmentCount: Number(stats.get(StatTypes.ASSIGNMENT_COUNT)) || 0,
    classCount: Number(stats.get(StatTypes.MY_CLASSES)) || 0,
    courseCount: Number(stats.get(StatTypes.COURSE_COUNT)) || 0,
    moduleCount: Number(stats.get(StatTypes.MODULE_COUNT)) || 0,
    resourceCount: Number(stats.get(StatTypes.RESOURCE_COUNT)) || 0,
    userCount: Number(stats.get(StatTypes.USER_COUNT)) || 0,
    archivedUserCount: Number(stats.get(StatTypes.USER_COUNT_ARCHIVED)) || 0,
    myEnrolmentStats: stats.get(StatTypes.MY_ENROLMENTS) || [],
    myResourceStats: stats.get(StatTypes.MY_RESOURCE_STATS) || [],
    courseStats: stats.get(StatTypes.COURSE_STATS) || [],
    visitStats: stats.get(StatTypes.USER_VISIT_STATS) || {},
});

Dashboard.getStores = () => ([StatStore, CourseComplianceStore, SettingStore]);
Dashboard.calculateState = (prevState) => ({
    ...sanitise(StatStore.getState()),
    siteKey: SettingStore.getValue('CENTRIC_SITE_KEY'),
    title: SettingStore.getValue('TITLE') || 'C-TMS'
});

export default Container.create(Dashboard);
